import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Feed } from './models/feed.model';
import { LoyaltyFeed } from './models/loyalty/loyalty-feed.model';

export interface FeedOptions {
  pageSize: number;
  pageNumber: number;
  totalPages: number;
}

export interface FeedState extends EntityState<Feed> {
  feeds: Feed[];
  options: FeedOptions;
  dynamicLoyaltyFeeds: LoyaltyFeed[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'feed', idKey: 'Id' })
export class FeedStore extends EntityStore<FeedState> {
  constructor() {
    super({
      feeds: [],
      options: {
        pageNumber: 0,
        pageSize: 20, // Default page size
        totalPages: 0,
      },
      loading: false,
    });
  }

  /**
   * Temporary adding as a workaround for the time being
   */
  addFeeds(feeds: Feed[]) {
    this.update((state) => {
      return {
        ...state,
        feeds: [...state.feeds, ...feeds],
      };
    });
  }

  setDynamicLoyaltyFeeds(loyaltyFeeds: LoyaltyFeed[]) {
    this.update({ dynamicLoyaltyFeeds: loyaltyFeeds });
  }

  setFeeds(feeds: Feed[]) {
    this.update({ feeds: feeds });
  }

  loadNewFeeds(...feeds: Feed[]) {
    this.update((state) => {
      return {
        ...state,
        feeds: [...feeds, ...state.feeds],
      };
    });
  }

  setOptions(options: FeedOptions) {
    this.update((state) => {
      return {
        ...state,
        options: {
          ...state.options,
          ...options,
        },
      };
    });
  }
}
